import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import React from "react";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import "./introduction.scss";
const Introduction = (props: ReferenciaContenido) => {
  const { tituloGeneral, redireccionBoton, descripcion } = props;
  return (
    <div className="">
      <div className="m-introduction">
        <div className="m-introduction__container">
          <div className="m-introduction__embed">
            <iframe
              className="gtmRedDeAmorVideoQueEsRedDeAmor"
              src={redireccionBoton}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            ></iframe>
          </div>
          <div className="m-introduction__content">
            <div>
              {tituloGeneral && (
                <h2 className="m-introduction__title">{tituloGeneral}</h2>
              )}
              {descripcion.raw && (
                <div className="m-introduction__description">
                  {documentToReactComponents(JSON.parse(descripcion?.raw))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Introduction;
